// Acciones (ej. recalcular estadísticas con el botón "Actualizar"); van encima de las secciones.
export function actionIndicators(state) {
    return state.permissions.filter(p => p.section === 'actions')
}

// Indicadores (KPIs), en el orden del catálogo del backend.
export function kpiIndicators(state) {
    return state.permissions.filter(p => p.section === 'kpis')
}

// Gráficas.
export function chartIndicators(state) {
    return state.permissions.filter(p => p.section === 'charts')
}
